import useUser from '@alltrails/context/hooks/useUser';
import { useLanguageCode } from '@alltrails/core/hooks/useLanguageCode';

export default function useAdaChatbot(): {
  isAdaReady: boolean;
  config: {
    handle: string | null;
    language: string;
  };
} {
  const languageCode = useLanguageCode();
  const user = useUser();

  const isAdaReady = Boolean(user);

  return {
    isAdaReady,
    config: {
      handle: process.env.NEXT_PUBLIC_ADA_HANDLE_GENERATIVE!,
      language: languageCode
    }
  };
}
